// Copyright 2020 Drivetrain Hub LLC
// Vuex module for managing engineering actions.
// `namespaced` option applies to getters, actions, and mutations; state is always namespaced.

import {apolloMutate, apolloQuery} from "../../config/apollo";
import {Notification} from 'element-ui';
import defaults from "../../config/defaults";
import requests from "../../requests";
import gql from "graphql-tag";

export default {
  namespaced: false,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // region UNUSED
    // async getFinishedRoot(_, gearId) {
    //   // API query to calculate detailed gear finished tooth root properties.
    //   // gearId arg - ID of GearDetail object, *not* Part object.
    //   // Returns GraphQL RootParams type for finished gear tooth.
    //
    //   const query = {
    //     errorPolicy: 'ignore',  // avoid error when tooth data cannot calculate; tooth: null
    //     fetchPolicy: 'network-only',
    //     variables: {
    //       Id: gearId,
    //     },
    //     // WARNING: Id must be included in query fields for Apollo to work correctly here.
    //     query: gql`query getFinishedRoot ($Id: ID!) {
    //       gearDetail (Id: $Id) {
    //         Id
    //         tooth {
    //           finishedRoot {
    //             ${requests.eng.RootParams}
    //           }
    //         }
    //       }
    //     }`,
    //   };
    //
    //   const { data } = await apolloQuery(query);
    //   return data.gearDetail.tooth.finishedRoot;
    // },
    // async getFinishedTeeth(_, gears) {
    //   // API query to calculate detailed gear finished tooth properties.
    //   // gears arg - Array of GearDetail objects, *not* Part objects.
    //   // Returns gears with the data structure of the input arg, plus a `tooth` prop with `finishedParams`.
    //   // WARNING: Values of NaN or Infinity are returned as strings.
    //
    //   const query = {
    //     errorPolicy: 'ignore',  // avoid error when tooth data cannot calculate; tooth: null
    //     fetchPolicy: 'network-only',
    //     variables: {
    //       Ids: gears.map(gear => gear.Id),
    //     },
    //     // WARNING: Id must be included in query fields for Apollo to work correctly here.
    //     // WARNING: API returns only the unique set of gears, i.e. duplicates in Ids are ignored.
    //     query: gql`query getTeeth ($Ids: [ID!]) {
    //       gearsDetail (Ids: $Ids) {
    //         Id
    //         tooth {
    //           finishedParams
    //         }
    //       }
    //     }`,
    //   };
    //   const { data } = await apolloQuery(query);
    //
    //   // merge response with the input gears
    //   return gears.map(gear => {
    //     const gearDetail = data.gearsDetail.find(g => g.Id === gear.Id);
    //     gear.tooth = gearDetail.tooth ? handlers.eng.parseTooth(gearDetail.tooth) : null;
    //     return gear;
    //   });
    // },
    // endregion
    async getMeshes({ rootState }, connections) {
      // API query to calculate gear mesh properties of connections with RATIO typ.
      // Works for all gear types, but returned `params` JSONString is different for different mesh types.
      // Returns array of Mesh class type, an extension of Connection type that takes care of parsing JSON mesh params.

      const query = {
        errorPolicy: 'ignore',  // avoid error when mesh data cannot calculate; mesh: null
        fetchPolicy: 'network-only',
        variables: {
          model: rootState.model.doc.Id,
          Ids: connections.map(conn => conn.Id),
        },
        // WARNING: Id must be included in query fields for Apollo to work correctly here.
        query: gql`query getMeshes ($model: ID! $Ids: [ID!]) {
          connections (model: $model, Ids: $Ids) {
            Id
            mesh {
              params
              warnings {
                name
                description
              }
              errors {
                name
                description
              }
            }
          }
        }`,
      };
      const { data } = await apolloQuery(query);

      // merge response with the input connections
      return connections.map(conn => {
        const meshConn = data.connections.find(c => c.Id === conn.Id);
        const mesh = !meshConn.mesh ? null : {...meshConn.mesh, params: JSON.parse(meshConn.mesh.params)};

        return {
          ...conn,
          mesh,
        }
      });
    },
    async runPowerflow({ commit, dispatch }, {Id, typ}) {
      // API mutation to run powerflow analysis.
      // Apollo automatically handles the cache update since response query uses the LoadCase schema.
      // Returns list of load cases with computed powerflow.

      commit('SET_STATUS', {message: 'Running powerflow'});
      Notification.info({
        position: defaults.notifyPosition,
        title: 'Powerflow',
        message: 'Analysis started'
      });

      // mutate DB
      const mutate = {
        variables: {Id, typ},
        mutation: gql`mutation runPowerflow ($Id: ID!, $typ: RunCaseType!) {
            runPowerflow (Id: $Id, typ: $typ) {
              success
              message
              loadCases {
                Id
                powerflow { 
                  ${requests.model.ResultsPowerflow}
                }
              }
            }
          }`,
      };
      const { data: { runPowerflow: { success, message, loadCases } } } = await apolloMutate(mutate)
        .finally(() => commit('CLEAR_STATUS'));

      // reset load case, if any
      dispatch('resetLoadCase');

      // notify user
      if (success) {
        Notification.success({
          position: defaults.notifyPosition,
          title: 'Powerflow',
          message: 'Analysis complete'
        });
      } else {
        Notification.error({
          position: defaults.notifyPosition,
          title: 'Powerflow',
          message: `Analysis stopped (${message})`
        });
      }

      return loadCases;
    },
  },
};
